import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import AppLayout from '@cloudscape-design/components/app-layout';
import SideNavigation from '@cloudscape-design/components/side-navigation';
import TopNavigation from '@cloudscape-design/components/top-navigation';
import { useAuth } from './AuthProvider';

/** Cloudscape chrome: top bar with sign-out + left nav, content rendered via <Outlet />. */
const AppShell: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useAuth();

  return (
    <>
      <div id="top-nav">
        <TopNavigation
          identity={{
            href: '/',
            title: 'Fly-in Spotter Admin',
            logo: { src: '/Flyin-Spotter-Logo.svg', alt: 'Fly-in Spotter' },
          }}
          utilities={[
            {
              type: 'menu-dropdown',
              text: user?.name ?? user?.email ?? 'Account',
              iconName: 'user-profile',
              items: [{ id: 'signout', text: 'Sign out' }],
              onItemClick: ({ detail }) => {
                if (detail.id === 'signout') void signOut();
              },
            },
          ]}
        />
      </div>
      <AppLayout
        toolsHide
        headerSelector="#top-nav"
        navigation={
          <SideNavigation
            activeHref={location.pathname}
            header={{ href: '/', text: 'Fly-in Spotter' }}
            onFollow={(e) => {
              if (!e.detail.external) {
                e.preventDefault();
                navigate(e.detail.href);
              }
            }}
            items={[
              { type: 'link', text: 'Dashboard', href: '/' },
              { type: 'link', text: 'Users', href: '/users' },
              { type: 'link', text: 'Fly-in Events', href: '/events' },
              { type: 'link', text: 'Story Sources', href: '/data-sources' },
              { type: 'link', text: 'Aircraft Stories', href: '/stories' },
              { type: 'link', text: 'Airframe Stories', href: '/airframe-stories' },
              { type: 'link', text: 'Story Feedback', href: '/story-feedback' },
              { type: 'link', text: 'App Feedback', href: '/app-feedback' },
              { type: 'link', text: 'Aircraft Registry', href: '/registry' },
              { type: 'link', text: 'Map Suppressions', href: '/suppressions' },
            ]}
          />
        }
        content={<Outlet />}
      />
    </>
  );
};

export default AppShell;
